import {useQuery} from '@tanstack/react-query';
import gigsApi from '@/api/gigs';
import {
  QUERY_STALE_TIME,
  FilterableGigsQueryOptions,
  getGigsQueryKey,
} from '../common';

// on count query we don't need to include any fields, so we omit the include option
export type UseGigsCountQueryOptions = Omit<
  FilterableGigsQueryOptions,
  'include'
>;

/**
 * Hook for fetching the count of gigs matching the provided filters
 */
export default function useGigsCountQuery(
  options: UseGigsCountQueryOptions = {}
) {
  const {enabled = true, params = {}} = options;

  return useQuery({
    queryKey: getGigsQueryKey('count', params),
    queryFn: async () => {
      const result = await gigsApi.filteredGigsCount(params);
      return result.count || 0;
    },
    enabled,
    refetchOnWindowFocus: false,
    staleTime: QUERY_STALE_TIME,
  });
}
